
import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  const { breakpoints } = useTheme()

  const sharedStyles = {
    squareButton: {
      color: colors.color5,
      borderRadius: '50%',
      boxShadow: `1px 1px 2px ${colors.color10}`,
      padding: '12px',
      background: colors.color30,
      '&:hover': {
        background: colors.color30 + 'dd',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.7rem',
      },
      //marginBottom: '2px',
    },
    flexBasic: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    errorAmount: {
      fontSize: '11px',
      color: colors.color19,
    },
  }


  return {
    title: {
      marginTop: 3,
      marginBottom: 2,
      '&.MuiTypography-root': {
        textAlign: "center"
      }
    },
    subTitle: {
      marginBottom: 3,
      '&.MuiTypography-root': {
        textAlign: "center"
      }
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '90vh',
    },
    bodyContainer: {
      flex: 1,
      overflow: 'auto',
      scrollbarWidth: 'none',
      padding: '0px 2px'
    },
    grid: {
      padding: '12px 32px',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      '&.brdLft': {
        //borderRight: `1px solid ${colors.color13}`,
        [breakpoints.up('lg')]: { boxShadow: '1px 0px #70707030' },
        //boxShadow: '1px 0px #70707030'
      }
    },
    informationAndEvidences: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    desbord: {
      '&.MuiTypography-root': { wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal", }
    },
    button: {
      display: 'flex',
      justifyContent: 'start',
      paddingLeft: 3,
      paddingTop: 3
    },
    clip: {
      ...sharedStyles.squareButton,
    },
  }
}

export { useStyles }
